import React from 'react'



import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import balajisare from "../images/balaji-saree bethua.jpg";
import showroom from "../images/aneek_textiles Brand.jpg";
import showroomimg from "../images/Balaji_saree Showroom photo.jpg";
import showroomphoto from "../images/jeans_stock photo.jpg";

import balajisare_newshowroom from "../images/balajee_saree Showroom.jpg"
import mens from "../images/mens-wear.jpg";
import showroomsaree from "../images/saree_counter.jpg";
import showroomwomenswearitem from "../images/Womens_wear photo.jpg";


import showroom_image from "../images/Showroom image.jpg";
import kidsitem from "../images/kids Items.jpg";
import womenswear from "../images/womens_wear item.jpg";
import jeanspantitem from "../images/pant_items.jpg";




function ShowroomPhoto() {
  return (
    <div>
          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={balajisare} className="card-img-top" alt="balajisare" />

                                            </Zoom>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={showroom} className="card-img-top" alt="showroom-photo"/>
                                            </Zoom>
                                            
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={showroomimg} className="card-img-top" alt="showroomimg"/>
                                            </Zoom>
                                   
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={showroomphoto} className="card-img-top" alt="showroomphoto" />
                                            </Zoom>
                                           
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={balajisare_newshowroom} className="card-img-top" alt="balajisare" />

                                            </Zoom>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={mens} className="card-img-top" alt="showroom-photo"/>
                                            </Zoom>
                                            
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={showroomsaree} className="card-img-top" alt="showroomimg"/>
                                            </Zoom>
                                   
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={showroomwomenswearitem} className="card-img-top" alt="showroomphoto" />
                                            </Zoom>
                                           
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={showroom_image} className="card-img-top" alt="showroom_image" />

                                            </Zoom>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={kidsitem} className="card-img-top" alt="kidsitem"/>
                                            </Zoom>
                                            
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={womenswear} className="card-img-top" alt="womenswear"/>
                                            </Zoom>
                                   
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='hovereffect'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={jeanspantitem} className="card-img-top" alt="jeanspantitem"/>
                                            </Zoom>
                                           
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br/>

    </div>
  )
}

export default ShowroomPhoto